import Vue from "vue";
import VueMoment from "vue-moment";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";

Vue.use(VueMoment);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  created() {
    this.$store.dispatch("auth/load");
  },
  render: h => h(App)
}).$mount("#app");
